
import { Breakpoint } from "@/types/breakpoints";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import defensiveCopy from "@/util/defensive-copy";
import EditBreakpoints from "./EditBreakpoints.vue";
import PreferencesPanel from "@/components/Settings/Preferences/PreferencesPanel.vue";
import { isEqual } from "lodash";

@Component({
  components: {
    EditBreakpoints,
    PreferencesPanel
  }
})
export default class CustomBreakpointsPanel extends Vue {
  @Prop()
  value!: Breakpoint[];

  internalValue = defensiveCopy(this.value);

  get unsavedChangesPresent() {
    return !isEqual(
      defensiveCopy(this.internalValue),
      defensiveCopy(this.value)
    );
  }

  applyChanges() {
    this.$emit("input", this.internalValue);
  }

  breakpointsEdited(customBreakpoints: Breakpoint[]) {
    this.internalValue = customBreakpoints;
  }
}
